import FormatError from '../system/FormatError';
import moment from 'moment';
export default class DefaultDateParser {
    parse(value) {
        const result = this.tryParse(value);
        if (result === undefined) {
            throw new FormatError(`'${value}' does not represent a Date in a valid format.`);
        }
        return result;
    }
    tryParse(value, valueOnFailure = undefined) {
        if (value === undefined) {
            return valueOnFailure;
        }
        else if (value instanceof Date) {
            return value;
        }
        else {
            const result = moment(value, true);
            if (result && result.isValid()) {
                return result.toDate();
            }
            else {
                return undefined;
            }
        }
    }
    ;
}
//# sourceMappingURL=DefaultDateParser.js.map